module.exports = __webpack_public_path__ + "static/media/penicon.ecedcc34.svg";